function arrivalCheckbox(checkbox, selector) {
	const liNode = checkbox.closest(selector)

	arrivalCheckboxHandler(liNode, checkbox.checked)
}